import React from "react";

import { BUILT_IN_OPERATORS } from "src/base-components/FilterPopover/operators";
import {
  ConditionRenderContext,
  FieldDefinition,
  FieldOverride,
  OperatorOption,
} from "src/base-components/FilterPopover/types";
import { BUILT_IN_RENDERERS } from "src/base-components/FilterPopover/ValueRenderers";

export const resolveValueRenderer = (
  field: FieldDefinition | undefined,
  fieldOverrides?: Record<string, FieldOverride>,
  valueRenderers?: Record<string, React.FC<ConditionRenderContext>>,
): React.FC<ConditionRenderContext> | null => {
  if (!field) return null;

  const fieldOverride = fieldOverrides?.[field.key]?.renderValue;
  if (fieldOverride) return fieldOverride;

  const typeOverride = valueRenderers?.[field.type];
  if (typeOverride) return typeOverride;

  return BUILT_IN_RENDERERS[field.type] ?? null;
};

export const resolveOperatorOptions = (
  field: FieldDefinition | undefined,
  fieldOverrides?: Record<string, FieldOverride>,
  operatorOptions?: Record<string, OperatorOption[]>,
): OperatorOption[] => {
  if (!field) return [];

  const fieldOverride = fieldOverrides?.[field.key]?.operatorOptions;
  if (fieldOverride) return fieldOverride;

  const typeOverride = operatorOptions?.[field.type];
  if (typeOverride) return typeOverride;

  return BUILT_IN_OPERATORS[field.type] ?? [];
};
